import R1 from "../../src/assets/img/allimages/dakshwomen_page-0001.jpg";
import R2 from "../../src/assets/img/allimages/dakshwomen_page-0002.jpg";
import R3 from "../../src/assets/img/allimages/new-2-min.jpg";
import R4 from "../../src/assets/img/allimages/new-4-min.jpg";
import R5 from "../../src/assets/img/allimages/new-5-min.jpg";
import R6 from "../../src/assets/img/allimages/new-6-min.jpg";
import R7 from "../../src/assets/img/allimages/dakshwomen_page-0003.jpg";
import R8 from "../../src/assets/img/allimages/new-8-min.jpg";
import R9 from "../../src/assets/img/allimages/new-9-min.jpg";
import R10 from "../../src/assets/img/allimages/new-10-min.jpg";
import R11 from "../../src/assets/img/allimages/new-11-min.jpg";
import R12 from "../../src/assets/img/allimages/new-12-min.jpg";
import R13 from "../../src/assets/img/allimages/new-13-min.jpg";
import R14 from "../../src/assets/img/allimages/new-14-min.jpg";
import R15 from "../../src/assets/img/allimages/new-15-min.jpg";
import R16 from "../../src/assets/img/allimages/new-16-min.jpg";
import R17 from "../../src/assets/img/allimages/new-17-min.jpg";
import R18 from "../../src/assets/img/allimages/new-18-min.jpg";
import R19 from "../../src/assets/img/allimages/new-19-min.jpg";
import R20 from "../../src/assets/img/allimages/new-20-min.jpg";
import R21 from "../../src/assets/img/allimages/new-21-min.jpg";
import R22 from "../../src/assets/img/allimages/new-22-min.jpg";
import R23 from "../../src/assets/img/allimages/new-23-min.jpg";
import R24 from "../../src/assets/img/allimages/new-24-min.jpg";
import R25 from "../../src/assets/img/allimages/new-25-min.jpg";
import R26 from "../../src/assets/img/allimages/new-26-min.jpg";
import R27 from "../../src/assets/img/allimages/new-27-min.jpg";
import R28 from "../../src/assets/img/allimages/new-28-min.jpg";
import R29 from "../../src/assets/img/allimages/new-29-min.jpg";
import R30 from "../../src/assets/img/allimages/new-30-min.jpg";
import R31 from "../../src/assets/img/allimages/new-31-min.jpg";
import R32 from "../../src/assets/img/allimages/new-32-min.jpg";
import R33 from "../../src/assets/img/allimages/new-33-min.jpg";
import R34 from "../../src/assets/img/allimages/new-34-min.jpg";
import R35 from "../../src/assets/img/allimages/new-35-min.jpg";
import R36 from "../../src/assets/img/allimages/new-36-min.jpg";
import R37 from "../../src/assets/img/allimages/new-37-min.jpg";
import R38 from "../../src/assets/img/allimages/new-38-min.jpg";
import R39 from "../../src/assets/img/allimages/new-39-min.jpg";
import R40 from "../../src/assets/img/allimages/new-40-min.jpg";
import R41 from "../../src/assets/img/allimages/new-41-min.jpg";
import R42 from "../../src/assets/img/allimages/new-42-min.jpg";
import R43 from "../../src/assets/img/allimages/new-43-min.jpg";
import R44 from "../../src/assets/img/allimages/dakshwomen_page-0004.jpg";
import R45 from "../../src/assets/img/allimages/dakshwomen_page-0005.jpg";
import { chartExample2 } from "variables/charts";
import CareerFormation from "utils/CareerFormation";

const commonFields = {
  personal: [
    {
      key: "userDataId.firstName",
      className: "l1",
      type: "black",
      format: { value: (v, obj) => `${obj.firstName}+${obj.lastName}` }
    },
    { key: "userDataId.class", className: "l2", type: "black" },
    { key: "userDataId.father_name", className: "l3", type: "black" },
    { key: "adminId.firstName", className: "l4", type: "black" },
    { key: "userDataId.dob", className: "l5", type: "black", format: { type: "date" } },
    { key: "userDataId.mobile", className: "l6", type: "black" },
    { key: "userDataId.address1", className: "l151", type: "black" }
  ],
  personality: [
    { key: "personality.primary", className: "l7", type: "black" },
    { key: "personality.secondary", className: "l8", type: "black" },
  ],
  tfrc: [
    {
      key: "tfrc",
      className: "l9",
      type: "value",
      format: { value: (v) => v || "" },
    },
  ],
  brain: [
    { key: "brain_dominance.left_brain", className: "l10 color-white", type: "value", format: { math: (v) => Math.round(v * 10000) / 100, suffix: "%" } },
    { key: "brain_dominance.right_brain", className: "l11", type: "value", format: { math: (v) => Math.round(v * 10000) / 100, suffix: "%" } },
  ],
  intrapersonal: [
    { key: "multiple_intelligence.intrapersonal.self", className: "l12", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "multiple_intelligence.intrapersonal.planning", className: "l13", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "multiple_intelligence.intrapersonal.emotion", className: "l14", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "multiple_intelligence.intrapersonal", className: "c1", type: "barChart", chart: { labels: ["Planning", "Emotion"], datasetKeys: ["planning", "emotion"], options: chartExample2.options, style: { width: "400px", height: "200px", background: "#fff", padding: "2px" } } }
  ],
  logical: [
    { key: "multiple_intelligence.logical_mathematical.self", className: "l15", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "multiple_intelligence.logical_mathematical.reasoning", className: "l16", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "multiple_intelligence.logical_mathematical.numerical", className: "l17", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "multiple_intelligence.logical_mathematical.geometry", className: "l18", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "multiple_intelligence.logical_mathematical", className: "c1", type: "barChart", chart: { labels: ["Reasoning", "Numerical", "Geometry"], datasetKeys: ["reasoning", "numerical", "geometry"], options: chartExample2.options, style: { width: "400px", height: "200px", background: "#fff", padding: "2px" } } }
  ],
  linguistic: [
    {
      key: "multiple_intelligence.linguistic.self",
      className: "l15",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.linguistic.nonVerbal",
      className: "l16",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.linguistic.verbal",
      className: "l19",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.linguistic.writing",
      className: "l18",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.linguistic",
      className: "c1",
      type: "barChart",
      chart: {
        labels: ["Non Verbal", "Verbal", "Writing"],
        datasetKeys: ["nonVerbal", "verbal", "writing"],
        options: chartExample2.options,
        style: { width: "400px", height: "200px", background: "#fff", padding: "2px" },
      },
    },
  ],
  naturalist: [
    {
      key: "multiple_intelligence.naturalist.self",
      className: "l20",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.naturalist.observation",
      className: "l21",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.naturalist.senses",
      className: "l22",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.naturalist",
      className: "c1",
      type: "barChart",
      chart: {
        labels: ["Observation", "Senses"],
        datasetKeys: ["observation", "senses"],
        options: chartExample2.options,
        style: { width: "400px", height: "200px", background: "#fff", padding: "2px" },
      },
    },
  ],
  interpersonnal: [
    {
      key: "multiple_intelligence.interpersonal.self",
      className: "l23",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.interpersonal.social",
      className: "l24",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.interpersonal.motivation",
      className: "l25",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.interpersonal",
      className: "c1",
      type: "barChart",
      chart: {
        labels: ["Social", "Motivation"],
        datasetKeys: ["social", "motivation"],
        options: chartExample2.options,
        style: { width: "400px", height: "200px", background: "#fff", padding: "2px" },
      },
    },
  ],
  visual: [
    {
      key: "multiple_intelligence.visual.self",
      className: "l26",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.visual.ideas",
      className: "l27",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.visual.sprituals",
      className: "l28",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.visual",
      className: "c2",
      type: "barChart",
      chart: {
        labels: ["3D Space", "Sprituals"],
        datasetKeys: ["ideas", "sprituals"],
        options: chartExample2.options,
        style: { width: "400px", height: "200px", background: "#fff", padding: "2px" },
      },
    },
  ],
  musical: [
    {
      key: "multiple_intelligence.musical.self",
      className: "l29",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.musical.voiceTone",
      className: "l16",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.musical.processing",
      className: "l30",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.musical.auditory",
      className: "l18",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.musical",
      className: "c2",
      type: "barChart",
      chart: {
        labels: ["Voice Tone", "Processing", "Auditory"],
        datasetKeys: ["voiceTone", "processing", "auditory"],
        options: chartExample2.options,
        style: { width: "400px", height: "200px", background: "#fff", padding: "2px" },
      },
    },
  ],
  kinesthetic: [
    {
      key: "multiple_intelligence.kinesthetic.self",
      className: "l26",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.kinesthetic.fineMotor",
      className: "l31",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.kinesthetic.vGrossMotor",
      className: "l28",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.kinesthetic",
      className: "c1",
      type: "barChart",
      chart: {
        labels: ["Fine Motor", "Gross Motor"],
        datasetKeys: ["fineMotor", "vGrossMotor"],
        options: chartExample2.options,
        style: { width: "400px", height: "200px", background: "#fff", padding: "2px" },
      },
    },
  ],
  senses: [
    { key: "senses.taste", className: "l32", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "senses.smell", className: "l33", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "senses.touch", className: "l34", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "senses.listen", className: "l35", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "senses.see", className: "l36", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    {
      key: "senses",
      className: "c2",
      type: "barChart",
      chart: {
        labels: ["Taste", "Smell", "Touch", "Listen", "See"],
        datasetKeys: ["taste", "smell", "touch", "listen", "see"],
        options: chartExample2.options,
        style: { width: "400px", height: "200px", background: "#fff", padding: "2px" },
      },
    },
  ],
  thought_process: [
    // { key: "thought_process.action", className: "l37", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    // { key: "thought_process.thinking", className: "l38", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    // { key: "thought_process.tactile", className: "l39", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    // { key: "thought_process.auditory", className: "l40", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    // { key: "thought_process.visual", className: "l41", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    {
      key: "thought_process",
      className: "c2",
      type: "barChart",
      chart: {
        labels: ["Action", "Thinking", "Tactile", "Auditory", "Visual"],
        datasetKeys: ["action", "thinking", "tactile", "auditory", "visual"],
        options: chartExample2.options,
        style: { width: "400px", height: "200px", background: "#fff", padding: "2px" },
      },
    },
  ],
  thoughts_process: [
    { key: "thought_process.action", className: "l37", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "thought_process.thinking", className: "l38", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "thought_process.tactile", className: "l39", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "thought_process.auditory", className: "l40", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    // { key: "thought_process.visual", className: "l41", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    {
      key: "thought_process",
      className: "c2",
      type: "barChart",
      chart: {
        labels: ["Action", "Thinking", "Tactile", "Auditory", "Visual"],
        datasetKeys: ["action", "thinking", "tactile", "auditory", "visual"],
        options: chartExample2.options,
        style: { width: "400px", height: "200px", background: "#fff", padding: "2px" },
      },
    },
  ],
  quotients: [
    { key: "quotients.iq", className: "l41", type: "value", format: { math: (v) => Math.round(v * 10) / 10 } },
    { key: "quotients.eq", className: "l42", type: "value", format: { math: (v) => Math.round(v * 10) / 10 } },
    { key: "quotients.cq", className: "l43", type: "value", format: { math: (v) => Math.round(v * 10) / 10 } },
    { key: "quotients.aq", className: "l44", type: "value", format: { math: (v) => Math.round(v * 10) / 10 } },
    {
      key: "quotients",
      className: "c3",
      type: "barChart",
      chart: {
        labels: ["IQ", "EQ", "CQ", "AQ"],
        datasetKeys: ["iq", "eq", "cq", "aq"],
        options: chartExample2.options,
        style: { width: "400px", height: "200px", background: "#fff", padding: "2px" },
      },
    },
  ],
  learning_style: [
    { key: "learning_style.visual", className: "l45", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "learning_style.auditory", className: "l46", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "learning_style.reading_writing", className: "l47", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    { key: "learning_style.kinesthetic", className: "l47", type: "value", format: { math: (v) => Math.round(v * 1000) / 10 } },
    {
      key: "learning_style",
      className: "c4",
      type: "barChart",
      chart: {
        labels: ["Visual", "Auditory", "Reading/Writing", "Kinesthetic"],
        datasetKeys: ["visual", "auditory", "reading_writing", "kinesthetic"],
        options: chartExample2.options,
        style: { width: "400px", height: "200px", background: "#fff", padding: "2px" },
      },
    },
  ],
  leadership_style: [
    {
      key: "leadership_style.task_oriented",
      className: "l48",
      type: "black",
      format: { math: (v) => Math.round(v) }
    },
    {
      key: "leadership_style.relationship_oriented",
      className: "l49",
      type: "value",
      format: { math: (v) => Math.round(v) }
    },
    {
      key: "leadership_style",
      className: "c1",
      type: "barChart",
      chart: {
        labels: ["Task Oriented", "Relationship Oriented"],
        datasetKeys: ["task_oriented", "relationship_oriented"],
        options: chartExample2.options,
        style: { width: "400px", height: "200px", background: "#fff", padding: "2px" },
      },
    },
  ],
  holland_theory: [
    { key: "holland_theory.realistic", className: "l50", type: "value", format: { math: v => Math.round(v * 1000) / 10 } },
    { key: "holland_theory.investigative", className: "l51", type: "value", format: { math: v => Math.round(v * 1000) / 10 } },
    { key: "holland_theory.conventional", className: "l52", type: "value", format: { math: v => Math.round(v * 1000) / 10 } },
    { key: "holland_theory.artistic", className: "l53", type: "value", format: { math: v => Math.round(v * 1000) / 10 } },
    { key: "holland_theory.enterprising", className: "l54", type: "value", format: { math: v => Math.round(v * 1000) / 10 } },
    { key: "holland_theory.social", className: "l55", type: "value", format: { math: v => Math.round(v * 1000) / 10 } },

    {
      key: "holland_theory",
      className: "c2",
      type: "barChart",
      chart: {
        labels: [
          "Realistic",
          "Investigative",
          "Conventional",
          "Artistic",
          "Enterprising",
          "Social"
        ],
        datasetKeys: [
          "realistic",
          "investigative",
          "conventional",
          "artistic",
          "enterprising",
          "social"
        ],
        options: chartExample2.options,
        style: { width: "400px", height: "200px", background: "#fff", padding: "2px" },
      },
    },
  ],
  mckenzie_theory: [
    { key: "mckenzie_theory.analytic", className: "l56", type: "value", format: { math: v => Math.round(v * 1000) / 10 } },
    { key: "mckenzie_theory.introspective", className: "l57", type: "value", format: { math: v => Math.round(v * 1000) / 10 } },
    { key: "mckenzie_theory.interactive", className: "l58", type: "value", format: { math: v => Math.round(v * 1000) / 10 } },

    {
      key: "mckenzie_theory",
      className: "c2",
      type: "barChart",
      chart: {
        labels: ["Analytic", "Introspective", "Interactive"],
        datasetKeys: ["analytic", "introspective", "interactive"],
        options: chartExample2.options,
        style: {
          width: "400px",
          height: "200px",
          background: "#fff",
          padding: "2px"
        },
      },
    },
  ],
  acquiring_methods: [
    { key: "acquiring_methods.reverse", className: "l56", type: "black" },
    { key: "acquiring_methods.self_cognitive", className: "l57", type: "black" },
    { key: "acquiring_methods.affective", className: "l58", type: "black" },
    { key: "acquiring_methods.reflective", className: "l59", type: "value" },

    {
      key: "acquiring_methods",
      className: "c2",
      type: "barChart",
      chart: {
        labels: ["Reverse", "Self Cognitive", "Affective", "Reflective"],
        datasetKeys: ["reverse", "self_cognitive", "affective", "reflective"],
        options: chartExample2.options,
        style: {
          width: "400px",
          height: "200px",
          background: "#fff",
          padding: "2px"
        }
      }
    }
  ],
  extra_curricular_activities: [
    { key: "extra_curricular_activities.dance", type: "value", format: { math: v => v * 100 } },
    { key: "extra_curricular_activities.instrumental_music", type: "value", format: { math: v => v * 100 } },
    { key: "extra_curricular_activities.singing", type: "value", format: { math: v => v * 100 } },
    { key: "extra_curricular_activities.acting", type: "value", format: { math: v => v * 100 } },
    { key: "extra_curricular_activities.swimming", type: "value", format: { math: v => v * 100 } },
    { key: "extra_curricular_activities.horse_riding", type: "value", format: { math: v => v * 100 } },
    { key: "extra_curricular_activities.chess", type: "value", format: { math: v => v * 100 } },
    { key: "extra_curricular_activities.snooker", type: "value", format: { math: v => v * 100 } },
    { key: "extra_curricular_activities.foreign_language", type: "value", format: { math: v => v * 100 } },
    { key: "extra_curricular_activities.painting", type: "value", format: { math: v => v * 100 } },
    {
      key: "extra_curricular_activities",
      className: "chart absolute c3 p-2",
      type: "barChart",

      style: { width: "600px", height: "400px", marginTop: "-10px", },

      chart: {
        labels: [
          "dance", "instrumental_music", "singing", "acting",
          "swimming", "horse_riding", "chess", "snooker",
          "foreign_language", "painting"
        ],

        datasetKeys: [
          "dance",
          "instrumental_music",
          "singing",
          "acting",
          "swimming",
          "horse_riding",
          "chess",
          "snooker",
          "foreign_language",
          "painting"
        ],

        style: { width: "400px", height: "200px", marginTop: "-20px", backgroundColor: "#fff" },

        options: {
          plugins: { legend: { display: false } },
          scales: {
            y: {
              beginAtZero: true,
              suggestedMin: 0,
              min: 0,
              max: 20,
              ticks: { stepSize: 5 }
            }
          }
        }}
      }
  ],
  stream_selection: [
    {
      key: "stream_selection.science",
      className: "l60",
      type: "value",
      format: { math: (v) => Math.round(v * 10000) / 100 }
    },
    {
      key: "stream_selection.commerce",
      className: "l61",
      type: "value",
      format: { math: (v) => Math.round(v * 10000) / 100 }
    },
    {
      key: "stream_selection.arts",
      className: "l62",
      type: "value",
      format: { math: (v) => Math.round(v * 10000) / 100 }
    },
    {
      key: "stream_selection",
      className: "c6 p-2",
      type: "pieChart",
      chart: {
        labels: ["Science", "Commerce", "Arts"],
        datasetKeys: [
          "science",
          "commerce",
          "arts"
        ],
        backgroundColor: ["#2e9db8", "#dc1c28", "#e9601a"],
        options: {
          plugins: {
            tooltip: {
              enabled: true,
              callbacks: {
                label: (context) => `${context.label}: ${context.parsed}%`,
              },
            },
          },
        },
        style: {
          width: "450px",
          height: "450px",
          marginBottom: "-185px",
          background: "transparent",
          padding: "2px",
        },
      },
    },
  ],
  career: [
    { key: "career.medical.doctor", className: "l63", type: "black", format: { fn: CareerFormation } },
    { key: "career.medical.pharmacist", className: "l64", type: "black", format: { fn: CareerFormation } },
    { key: "career.medical.nutritionist", className: "l65", type: "black", format: { fn: CareerFormation } },
    { key: "career.medical.drug_officer", className: "l66", type: "black", format: { fn: CareerFormation } },
    { key: "career.medical.medical_officer", className: "l67", type: "black", format: { fn: CareerFormation } },
    { key: "career.medical.surgeon", className: "l68", type: "black", format: { fn: CareerFormation } },
    { key: "career.medical.chemist", className: "l69", type: "black", format: { fn: CareerFormation } },
    { key: "career.medical.food_inspector", className: "l70", type: "black", format: { fn: CareerFormation } },
    { key: "career.engineering.chemical_engineering", className: "l71", type: "value", format: { fn: CareerFormation } },
    { key: "career.engineering.mechanical_engineering", className: "l72", type: "value", format: { fn: CareerFormation } },
    { key: "career.engineering.electronical_engineering", className: "l73", type: "value", format: { fn: CareerFormation } },
    { key: "career.engineering.computer_engineering", className: "l74", type: "value", format: { fn: CareerFormation } },
    { key: "career.engineering.electrical_engineering", className: "l75", type: "value", format: { fn: CareerFormation } },
    { key: "career.engineering.production_engineering", className: "l76", type: "value", format: { fn: CareerFormation } },
    { key: "career.engineering.aviation_engineering", className: "l77", type: "value", format: { fn: CareerFormation } },
    { key: "career.engineering.sound_engineering", className: "l78", type: "value", format: { fn: CareerFormation } },
    { key: "career.music.music_teacher", className: "l63", type: "black", format: { fn: CareerFormation } },
    { key: "career.music.music_composer", className: "l64", type: "black", format: { fn: CareerFormation } },
    { key: "career.music.music_director", className: "l65", type: "black", format: { fn: CareerFormation } },
    { key: "career.music.singer", className: "l66", type: "black", format: { fn: CareerFormation } },
    { key: "career.music.musical_instrument_artist", className: "l67", type: "black", format: { fn: CareerFormation } },
    { key: "career.music.piano_artist", className: "l68", type: "black", format: { fn: CareerFormation } },
    { key: "career.music.voice_recognizer", className: "l69", type: "black", format: { fn: CareerFormation } },
    { key: "career.music.guitar_artist", className: "l70", type: "black", format: { fn: CareerFormation } },
    { key: "career.music.dancer", className: "l79", type: "black", format: { fn: CareerFormation } },
    { key: "career.music.choreographer", className: "l80", type: "black", format: { fn: CareerFormation } },
    { key: "career.life_science.biology_teacher", className: "l73", type: "value", format: { fn: CareerFormation } },
    { key: "career.life_science.pathology_reseacher", className: "l74", type: "value", format: { fn: CareerFormation } },
    { key: "career.life_science.biotechnology_researcher", className: "l75", type: "value", format: { fn: CareerFormation } },
    { key: "career.life_science.vaternary_doctor", className: "l76", type: "value", format: { fn: CareerFormation } },
    { key: "career.life_science.botany_professor", className: "l77", type: "value", format: { fn: CareerFormation } },
    { key: "career.life_science.animal_plant_researcher", className: "l78", type: "value", format: { fn: CareerFormation } },
    { key: "career.designing.fashion_designer", className: "l63", type: "black", format: { fn: CareerFormation } },
    { key: "career.designing.map_designer", className: "l64", type: "black", format: { fn: CareerFormation } },
    { key: "career.designing.architect", className: "l65", type: "black", format: { fn: CareerFormation } },
    { key: "career.designing.interior_designer", className: "l66", type: "black", format: { fn: CareerFormation } },
    { key: "career.designing.web_designer", className: "l67", type: "black", format: { fn: CareerFormation } },
    { key: "career.designing.car_bike_designer", className: "l68", type: "black", format: { fn: CareerFormation } },
    { key: "career.designing.software_designer", className: "l69", type: "black", format: { fn: CareerFormation } },
    { key: "career.designing.wedding_planner", className: "l70", type: "black", format: { fn: CareerFormation } },
    { key: "career.weather_environment_science.geography_professor", className: "l71", type: "value", format: { fn: CareerFormation } },
    { key: "career.weather_environment_science.geo_science", className: "l72", type: "value", format: { fn: CareerFormation } },
    { key: "career.weather_environment_science.environment_researcher", className: "l73", type: "value", format: { fn: CareerFormation } },
    { key: "career.weather_environment_science.archeology", className: "l74", type: "value", format: { fn: CareerFormation } },
    { key: "career.weather_environment_science.soil_researcher", className: "l75", type: "value", format: { fn: CareerFormation } },
    { key: "career.weather_environment_science.water_harveter", className: "l76", type: "value", format: { fn: CareerFormation } },
    { key: "career.weather_environment_science.agriculture", className: "l77", type: "value", format: { fn: CareerFormation } },
    { key: "career.weather_environment_science.forest_officer", className: "l78", type: "value", format: { fn: CareerFormation } },
    { key: "career.banking_finance.chartered_account", className: "l63", type: "black", format: { fn: CareerFormation } },
    { key: "career.banking_finance.financial_officer", className: "l64", type: "black", format: { fn: CareerFormation } },
    { key: "career.banking_finance.insurance_agent", className: "l65", type: "black", format: { fn: CareerFormation } },
    { key: "career.banking_finance.tax_consultant", className: "l66", type: "black", format: { fn: CareerFormation } },
    { key: "career.banking_finance.investment_banker", className: "l67", type: "black", format: { fn: CareerFormation } },
    { key: "career.banking_finance.equity_reseacher", className: "l68", type: "black", format: { fn: CareerFormation } },
    { key: "career.banking_finance.wealth_manager", className: "l69", type: "black", format: { fn: CareerFormation } },
    { key: "career.banking_finance.bank_teller", className: "l70", type: "black", format: { fn: CareerFormation } },
    { key: "career.mass_media_communication.language_expert", className: "l71", type: "value", format: { fn: CareerFormation } },
    { key: "career.mass_media_communication.newsreader", className: "l72", type: "value", format: { fn: CareerFormation } },
    { key: "career.mass_media_communication.anchor_radio_jockey", className: "l73", type: "value", format: { fn: CareerFormation } },
    { key: "career.mass_media_communication.poet", className: "l74", type: "value", format: { fn: CareerFormation } },
    { key: "career.mass_media_communication.writer_author", className: "l75", type: "value", format: { fn: CareerFormation } },
    { key: "career.mass_media_communication.journalist", className: "l76", type: "value", format: { fn: CareerFormation } },
    { key: "career.mass_media_communication.news_editor", className: "l77", type: "value", format: { fn: CareerFormation } },
    { key: "career.mass_media_communication.public_relation_officer", className: "l78", type: "value", format: { fn: CareerFormation } },
    { key: "career.literature.hindi_english_teacher", className: "l81", type: "black", format: { fn: CareerFormation } },
    { key: "career.literature.poet", className: "l82", type: "black", format: { fn: CareerFormation } },
    { key: "career.literature.philosopher", className: "l83", type: "black", format: { fn: CareerFormation } },
    { key: "career.literature.grammar_expert", className: "l84", type: "black", format: { fn: CareerFormation } },
    { key: "career.mathematics.mathematician", className: "l85", type: "value", format: { fn: CareerFormation } },
    { key: "career.mathematics.physicist", className: "l86", type: "value", format: { fn: CareerFormation } },
    { key: "career.mathematics.chemical_expert", className: "l87", type: "value", format: { fn: CareerFormation } },
    { key: "career.mathematics.business_analyst", className: "l88", type: "value", format: { fn: CareerFormation } },
    { key: "career.mathematics.accountant", className: "l89", type: "value", format: { fn: CareerFormation } },
    { key: "career.mathematics.statistician", className: "l90", type: "value", format: { fn: CareerFormation } },
    { key: "career.mathematics.actuary", className: "l91", type: "value", format: { fn: CareerFormation } },
    { key: "career.mathematics.economist", className: "l92", type: "value", format: { fn: CareerFormation } },
    { key: "career.mathematics.chartered_account", className: "l93", type: "value", format: { fn: CareerFormation } },
    { key: "career.mathematics.company_secretary", className: "l94", type: "value", format: { fn: CareerFormation } },
    { key: "career.management.hr_management", className: "l81", type: "black", format: { fn: CareerFormation } },
    { key: "career.management.marketing_management", className: "l82", type: "black", format: { fn: CareerFormation } },
    { key: "career.management.business_management", className: "l83", type: "black", format: { fn: CareerFormation } },
    { key: "career.management.production_management", className: "l84", type: "black", format: { fn: CareerFormation } },
    { key: "career.management.tourism_management", className: "l95", type: "black", format: { fn: CareerFormation } },
    { key: "career.management.sales_management", className: "l96", type: "black", format: { fn: CareerFormation } },
    { key: "career.public_political_affairs.politician", className: "l97", type: "value", format: { fn: CareerFormation } },
    { key: "career.public_political_affairs.ias_ips_officer", className: "l98", type: "value", format: { fn: CareerFormation } },
    { key: "career.public_political_affairs.lawyer", className: "l99", type: "value", format: { fn: CareerFormation } },
    { key: "career.public_political_affairs.teacher_professor", className: "l100", type: "value", format: { fn: CareerFormation } },
    { key: "career.public_political_affairs.judge", className: "l101", type: "value", format: { fn: CareerFormation } },
    { key: "career.public_political_affairs.administrator", className: "l102", type: "value", format: { fn: CareerFormation } },
    { key: "career.public_political_affairs.public_relation_officer", className: "l103", type: "value", format: { fn: CareerFormation } },
    { key: "career.public_political_affairs.counselor", className: "l104", type: "value", format: { fn: CareerFormation } },
    { key: "career.psychology.psychologist", className: "l117", type: "value", format: { fn: CareerFormation } },
    { key: "career.psychology.marriage_counselor", className: "l118", type: "value", format: { fn: CareerFormation } },
    { key: "career.psychology.career_counselor", className: "l119", type: "value", format: { fn: CareerFormation } },
    { key: "career.psychology.parenting_counselor", className: "l120", type: "value", format: { fn: CareerFormation } },
    { key: "career.psychology.mediator", className: "l105", type: "value", format: { fn: CareerFormation } },
    { key: "career.psychology.spritual_leader", className: "l106", type: "value", format: { fn: CareerFormation } },
    { key: "career.foreign_language.translator", className: "l107", type: "black", format: { fn: CareerFormation } },
    { key: "career.foreign_language.language_teacher", className: "l108", type: "black", format: { fn: CareerFormation } },
    { key: "career.foreign_language.interpretor", className: "l109", type: "black", format: { fn: CareerFormation } },
    { key: "career.foreign_language.grammar_expert", className: "l110", type: "black", format: { fn: CareerFormation } },
    { key: "career.foreign_language.newsreader", className: "l111", type: "black", format: { fn: CareerFormation } },
    { key: "career.foreign_language.anchor", className: "l112", type: "black", format: { fn: CareerFormation } },
    { key: "career.foreign_language.trainer", className: "l113", type: "black", format: { fn: CareerFormation } },
    { key: "career.foreign_language.motivational_speaker", className: "l114", type: "black", format: { fn: CareerFormation } },
    { key: "career.foreign_language.language_researcher", className: "l115", type: "black", format: { fn: CareerFormation } },
    { key: "career.foreign_language.speech_therapist", className: "l116", type: "black", format: { fn: CareerFormation } },
    { key: "career.sport.cricket", className: "l117", type: "value", format: { fn: CareerFormation } },
    { key: "career.sport.football", className: "l118", type: "value", format: { fn: CareerFormation } },
    { key: "career.sport.tennis", className: "l119", type: "value", format: { fn: CareerFormation } },
    { key: "career.sport.swimming", className: "l120", type: "value", format: { fn: CareerFormation } },
    { key: "career.sport.snooker", className: "l105", type: "value", format: { fn: CareerFormation } },
    { key: "career.sport.carom", className: "l106", type: "value", format: { fn: CareerFormation } },
    { key: "career.defence.army", className: "l107", type: "black", format: { fn: CareerFormation } },
    { key: "career.defence.air_force", className: "l108", type: "black", format: { fn: CareerFormation } },
    { key: "career.defence.police", className: "l109", type: "black", format: { fn: CareerFormation } },
    { key: "career.defence.crpf", className: "l110", type: "black", format: { fn: CareerFormation } },
    { key: "career.defence.fire_brigade_officer", className: "l111", type: "black", format: { fn: CareerFormation } },
    { key: "career.defence.navy", className: "l112", type: "black", format: { fn: CareerFormation } },
    { key: "career.defence.national_disaster_management_system", className: "l113", type: "black", format: { fn: CareerFormation } },
    { key: "career.defence.nurse", className: "l114", type: "black", format: { fn: CareerFormation } },
    { key: "career.defence.athelete", className: "l115", type: "black", format: { fn: CareerFormation } },
    { key: "career.defence.shooter", className: "l116", type: "black", format: { fn: CareerFormation } },

  ],
  career_master_chart: [
    {
      key: "career",
      className: "c5",
      type: "barChart",
      chart: {
        labels: [
          "Medical",
          "Engineering",
          "Music",
          "Life Science",
          "Designing",
          "Environment Science",
          "Banking Finance",
          "Mass Communication",
          "Literature",
          "Mathematics",
          "Management",
          "Public Affairs",
          "Psychology",
          "Foreign Language",
          "Sport",
          "Defence",
        ],
        datasetKeys: [
          "medical.self",
          "engineering.self",
          "music.self",
          "life_science.self",
          "designing.self",
          "weather_environment_science.self",
          "banking_finance.self",
          "mass_media_communication.self",
          "literature.self",
          "mathematics.self",
          "management.self",
          "public_political_affairs.self",
          "psychology.self",
          "foreign_language.self",
          "sport.self",
          "defence.self"
        ],
        style: { width: "700px", height: "450px", background: "#fff", padding: "2px" }
      }
    }
  ],
  dashboard_summary: [
    {
      key: "multiple_intelligence.intrapersonal.self",
      className: "l121",
      type: "value",
      format: { math: (v) => Math.round(v * 10000) / 100 }
    },
    {
      key: "multiple_intelligence.interpersonal.self",
      className: "l122",
      type: "value",
      format: { math: (v) => Math.round(v * 10000) / 100 }
    },
    {
      key: "multiple_intelligence.logical_mathematical.self",
      className: "l123",
      type: "value",
      format: { math: (v) => Math.round(v * 10000) / 100 }
    },
    {
      key: "multiple_intelligence.visual.self",
      className: "l124",
      type: "value",
      format: { math: (v) => Math.round(v * 10000) / 100 }
    },
    {
      key: "multiple_intelligence.linguistic.self",
      className: "l125",
      type: "value",
      format: { math: (v) => Math.round(v * 10000) / 100 }
    },
    {
      key: "multiple_intelligence.kinesthetic.self",
      className: "l126",
      type: "value",
      format: { math: (v) => Math.round(v * 10000) / 100 }
    },
    {
      key: "multiple_intelligence.naturalist.self",
      className: "l127",
      type: "value",
      format: { math: (v) => Math.round(v * 10000) / 100 }
    },
    {
      key: "multiple_intelligence.musical.self",
      className: "l128",
      type: "value",
      format: { math: (v) => Math.round(v * 10000) / 100 }
    },
    {
      key: "personality.primary",
      className: "l129",
      type: "value"
    },
    {
      key: "personality.secondary",
      className: "l130",
      type: "value"
    },
    {
      key: "brain_dominance.left_brain",
      className: "l131",
      type: "value",
      format: { math: (v) => Math.round(v * 10000) / 100 }
    },
    {
      key: "brain_dominance.right_brain",
      className: "l132",
      type: "value",
      format: { math: (v) => Math.round(v * 10000) / 100 }
    }
  ],
  personal_analysis: [
    { key: "learning_style.visual", className: "l133", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "learning_style.auditory", className: "l134", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "learning_style.kinesthetic", className: "l135", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "leadership_style.task_oriented", className: "l136", type: "value", format: { math: v => Math.round(v) } },
    { key: "leadership_style.relationship_oriented", className: "l137", type: "value", format: { math: v => Math.round(v) } },
    { key: "stream_selection.science", className: "l138", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "stream_selection.commerce", className: "l139", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "stream_selection.arts", className: "l140", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "senses.touch", className: "l141", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "senses.taste", className: "l142", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "senses.smell", className: "l143", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "senses.listen", className: "l144", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "senses.see", className: "l145", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "thought_process.action", className: "l146", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "thought_process.thinking", className: "l147", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "thought_process.tactile", className: "l148", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "thought_process.auditory", className: "l149", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    { key: "thought_process.visual", className: "l150", type: "value", format: { math: v => Math.round(v * 10000) / 100 } },
    {
      key: "quotients",
      className: "c4",
      type: "barChart",
      chart: {
        labels: ["IQ", "EQ", "CQ", "AQ"],
        datasetKeys: ["iq", "eq", "cq", "aq"],
        maxBarThickness: 20,
        options: chartExample2?.options,
        style: {
          width: "300px",
          height: "150px",
          background: "#fff",
          padding: "2px"
        }
      }
    }
  ],
  multiple_intelligence_self: [
    {
      key: "multiple_intelligence.logical_mathematical.self",
      className: "l90",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.linguistic.self",
      className: "l91",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.visual.self",
      className: "l92",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.kinesthetic.self",
      className: "l93",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.naturalist.self",
      className: "l94",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.intrapersonal.self",
      className: "l95",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence.musical.self",
      className: "l96",
      type: "value",
      format: { math: (v) => Math.round(v * 1000) / 10 },
    },
    {
      key: "multiple_intelligence",
      className: "c7",
      type: "barChart",
      chart: {
        labels: [
          "Logical-Mathematical",
          "Intrapersonal",
          "Linguistic",
          "Naturalist",
          "Visual",
          "Music",
          "Kinesthetic",
        ],
        datasetKeys: [
          "logical_mathematical.self",
          "intrapersonal.self",
          "linguistic.self",
          "naturalist.self",
          "visual.self",
          "musical.self",
          "kinesthetic.self",
        ],
        options: chartExample2.options,
        style: {
          width: "500px",
          height: "250px",
          background: "#fff",
          padding: "2px",
          marginTop: "-320px",
          marginLeft: "480px",
        },
      },
    },
  ]
};

export const reportConfig = {
  small: [
    { pageName: R1, fields: [] },
    { pageName: R2, fields: commonFields.personal },
    { pageName: R7, fields: commonFields.personality },
    { pageName: R45, fields: [] }
  ],
  medium: [
    { pageName: R1, fields: [] },
    { pageName: R2, fields: commonFields.personal },
    { pageName: R7, fields: commonFields.personality },
    { pageName: R44, fields: [commonFields.multiple_intelligence_self[7]] },
    { pageName: R45, fields: [] }
  ],
  full: [
    { pageName: R1, fields: [] },
    { pageName: R2, fields: commonFields.personal },
    { pageName: R3, fields: [] },
    { pageName: R4, fields: [] },
    { pageName: R5, fields: [] },
    { pageName: R6, fields: [] },
    { pageName: R7, fields: commonFields.personality },
    { pageName: R8, fields: [] },
    { pageName: R9, fields: commonFields.tfrc },
    { pageName: R10, fields: commonFields.brain },
    { pageName: R11, fields: [] },
    { pageName: R12, fields: commonFields.intrapersonal },
    { pageName: R13, fields: commonFields.logical },
    { pageName: R14, fields: commonFields.linguistic },
    { pageName: R15, fields: commonFields.naturalist },
    { pageName: R16, fields: commonFields.interpersonnal },
    { pageName: R17, fields: commonFields.visual },
    { pageName: R18, fields: commonFields.musical },
    { pageName: R19, fields: commonFields.kinesthetic },
    { pageName: R20, fields: commonFields.senses },
    { pageName: R21, fields: commonFields.thought_process },
    { pageName: R22, fields: [commonFields.thoughts_process[0], commonFields.thoughts_process[1], commonFields.thoughts_process[2], commonFields.thoughts_process[3]] },
    { pageName: R23, fields: commonFields.quotients },
    { pageName: R24, fields: [commonFields.learning_style[0]] },
    { pageName: R25, fields: [commonFields.learning_style[1]] },
    { pageName: R26, fields: [commonFields.learning_style[3]] },
    { pageName: R27, fields: [commonFields.leadership_style[0], commonFields.leadership_style[1], commonFields.leadership_style[2]] },
    { pageName: R28, fields: [commonFields.holland_theory[0], commonFields.holland_theory[1], commonFields.holland_theory[2], commonFields.holland_theory[3], commonFields.holland_theory[4], commonFields.holland_theory[5], commonFields.holland_theory[6]] },
    { pageName: R29, fields: [commonFields.mckenzie_theory[3]] },
    { pageName: R30, fields: [commonFields.acquiring_methods[0], commonFields.acquiring_methods[1], commonFields.acquiring_methods[2], commonFields.acquiring_methods[3]] },
    { pageName: R31, fields: [commonFields.extra_curricular_activities[10]] },
    { pageName: R32, fields: [commonFields.stream_selection[0], commonFields.stream_selection[1], commonFields.stream_selection[2], commonFields.stream_selection[3]] },
    { pageName: R33, fields: [commonFields.career[0], commonFields.career[1], commonFields.career[2], commonFields.career[3], commonFields.career[4], commonFields.career[5], commonFields.career[6], commonFields.career[7], commonFields.career[8], commonFields.career[9], commonFields.career[10], commonFields.career[11], commonFields.career[12], commonFields.career[13], commonFields.career[14], commonFields.career[15], commonFields.career[16], commonFields.career[17]] },
    { pageName: R34, fields: [commonFields.career[18], commonFields.career[19], commonFields.career[20], commonFields.career[21], commonFields.career[22], commonFields.career[23], commonFields.career[24], commonFields.career[25], commonFields.career[26], commonFields.career[27], commonFields.career[28], commonFields.career[29], commonFields.career[30], commonFields.career[31], commonFields.career[32], commonFields.career[33]] },
    { pageName: R35, fields: [commonFields.career[34], commonFields.career[35], commonFields.career[36], commonFields.career[37], commonFields.career[38], commonFields.career[39], commonFields.career[40], commonFields.career[41], commonFields.career[42], commonFields.career[43], commonFields.career[44], commonFields.career[45], commonFields.career[46], commonFields.career[47], commonFields.career[48], commonFields.career[49]] },
    { pageName: R36, fields: [commonFields.career[50], commonFields.career[51], commonFields.career[52], commonFields.career[53], commonFields.career[54], commonFields.career[55], commonFields.career[56], commonFields.career[57], commonFields.career[58], commonFields.career[59], commonFields.career[60], commonFields.career[61], commonFields.career[62], commonFields.career[63], commonFields.career[64], commonFields.career[65]] },
    { pageName: R37, fields: [commonFields.career[66], commonFields.career[67], commonFields.career[68], commonFields.career[69], commonFields.career[70], commonFields.career[71], commonFields.career[72], commonFields.career[73], commonFields.career[74], commonFields.career[75], commonFields.career[76], commonFields.career[77], commonFields.career[78], commonFields.career[79]] },
    { pageName: R38, fields: [commonFields.career[80], commonFields.career[81], commonFields.career[82], commonFields.career[83], commonFields.career[84], commonFields.career[85], commonFields.career[86], commonFields.career[87], commonFields.career[88], commonFields.career[89], commonFields.career[90], commonFields.career[91],] },
    { pageName: R39, fields: [commonFields.career[92], commonFields.career[93], commonFields.career[94], commonFields.career[95], commonFields.career[96], commonFields.career[97], commonFields.career[98], commonFields.career[99]] },
    { pageName: R40, fields: [commonFields.career[100], commonFields.career[101], commonFields.career[102], commonFields.career[103], commonFields.career[104], commonFields.career[105], commonFields.career[106], commonFields.career[107], commonFields.career[108], commonFields.career[109], commonFields.career[110], commonFields.career[111], commonFields.career[112], commonFields.career[113], commonFields.career[114], commonFields.career[115],] },
    { pageName: R41, fields: commonFields.career_master_chart },
    { pageName: R42, fields: commonFields.dashboard_summary },
    { pageName: R43, fields: commonFields.personal_analysis },
    // { pageName: R44, fields: [commonFields.multiple_intelligence_self[7]] },
    { pageName: R45, fields: [] }
  ]
};